export default __webpack_public_path__ + "static/media/Cheffy_content1.36241154.jpg";